import { SegmentEventActionNames } from 'utils/segment/constants';

export const getFieldActionName = (fieldName: string) => {
    switch (fieldName) {
        case 'name':
            return SegmentEventActionNames.ENTER_NAME;
        case 'mobile':
            return SegmentEventActionNames.ENTER_MOBILE_NUMBER;
        case 'email':
            return SegmentEventActionNames.ENTER_EMAIL;
        case 'address':
            return SegmentEventActionNames.ENTER_ADDRESS;
        case 'pincode':
            return SegmentEventActionNames.ENTER_PINCODE;
        default:
            return SegmentEventActionNames.ENTER_VALUE;
    }
};
